
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorChatActivo } from '../../controlador';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Factura } from '@/__env/lib/CuentasCorrientes/Facturas';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import cliente from './resumen-cliente.vue';
    import items from './resumen-items.vue';
    import transporte from './resumen-transporte.vue';
    import destino from './resumen-destino.vue';
    import facturas from './resumen-facturas.vue';
    import pagos from './resumen-pagos.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            cliente,
            items,
            facturas,
            destino,
            transporte,
            pagos,
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorChatActivo;
        public get Chat() { return this.Controlador.Chat; }
        public get ControladorBarras() { return this.Controlador.ControladorBarrasLaterales; }
        public get SubModo() { return this.ControladorBarras.Vista.SubModo; }
        public set SubModo( x: string ) { this.ControladorBarras.Vista.SubModo = x; }
        public get Pedido() { return this.ControladorBarras.PedidoSeleccionado; }

        public Archivo: File = null;
        public SeleccionarArchivo: boolean = false;

        async mounted()
        {
            if ( !this.Pedido )
            {
                return;
            }

            this.Controlador.Vista.ReservarEspacioDerecha.Espacio = 600;
            this.Iniciar();
        }



        public Cargando: boolean = false;
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }


        async Iniciar()
        {
            await this.Pedido.CargarPagos();
        }


        async Abrir()
        {
            window.open( this.Pedido.DeclaracionBienDeUso );

        }




        async Cerrar()
        {
            this.SubModo = 'pedidos';
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
